var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "member-history-container" }, [
    _c("div", { staticClass: "history-header" }, [
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
    ]),
    _vm.showCategoryFilter && _vm.categoryOptions.length > 0
      ? _c(
          "div",
          { staticClass: "filter-row" },
          [
            _c("label", [_vm._v("Filter by category:")]),
            _c(
              "md-field",
              { staticClass: "category-filter" },
              [
                _c(
                  "md-select",
                  {
                    on: { "md-selected": _vm.handleFilterCategory },
                    model: {
                      value: _vm.selectedCategory,
                      callback: function ($$v) {
                        _vm.selectedCategory = $$v
                      },
                      expression: "selectedCategory",
                    },
                  },
                  [
                    _c("md-option", { attrs: { value: "all" } }, [
                      _vm._v("All"),
                    ]),
                    _vm._l(_vm.categoryOptions, function (option) {
                      return _c(
                        "md-option",
                        { key: option.id, attrs: { value: option.id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(option.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _c("span", { staticClass: "entry-count" }, [
              _vm._v(
                "\n            Showing " +
                  _vm._s(_vm.filteredItems.length) +
                  " of " +
                  _vm._s(
                    _vm.hasMore ? _vm.totalCount : _vm.filteredItems.length
                  ) +
                  " entries\n        "
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm.loading
      ? _c("div", { staticClass: "loading-container" }, [
          _c("p", [_vm._v("Loading history...")]),
        ])
      : _vm.filteredItems.length === 0
      ? _c("div", { staticClass: "empty-state" }, [
          _c("p", [_vm._v(_vm._s(_vm.emptyStateMessage))]),
        ])
      : _c("div", { ref: "historyTable", staticClass: "history-table" }, [
          _c("table", [
            _vm._m(0),
            _c(
              "tbody",
              _vm._l(_vm.filteredItems, function (item, index) {
                return _c("tr", { key: _vm.getUniqueKey(item, index) }, [
                  _c("td", { staticClass: "timestamp" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("dateFormat")(
                          item.createdDate,
                          _vm.DATE_TYPES.standardDateTime
                        )
                      )
                    ),
                  ]),
                  _c("td", { staticClass: "user" }, [
                    _vm._v(_vm._s(item.changedByUserFullName)),
                  ]),
                  _c("td", { staticClass: "category" }, [
                    _c(
                      "span",
                      {
                        staticClass: "badge",
                        class: _vm.getCategoryBadgeClass(item.category),
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.getCategoryName(item.category)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                  _c("td", { staticClass: "change" }, [
                    _c("span", { staticClass: "field-name" }, [
                      _vm._v(_vm._s(item.fieldName)),
                    ]),
                    _vm.shouldShowJsonDiff(item.oldValue, item.newValue)
                      ? _c(
                          "span",
                          _vm._l(
                            _vm.getJsonDiff(item.oldValue, item.newValue),
                            function (change, changeIndex) {
                              return _c(
                                "div",
                                {
                                  key:
                                    _vm.getUniqueKey(item, index) +
                                    "-change-" +
                                    changeIndex,
                                  staticClass: "json-change",
                                },
                                [
                                  _c("span", { staticClass: "json-path" }, [
                                    _vm._v(_vm._s(change.path)),
                                  ]),
                                  _c("span", { staticClass: "change-text" }, [
                                    _vm._v("changed from"),
                                  ]),
                                  _vm.isBlank(change.oldValue)
                                    ? _c(
                                        "span",
                                        { staticClass: "blank-value" },
                                        [_vm._v("blank")]
                                      )
                                    : _c("span", { staticClass: "old-value" }, [
                                        _vm._v(_vm._s(change.oldValue)),
                                      ]),
                                  _c("span", { staticClass: "change-text" }, [
                                    _vm._v("to"),
                                  ]),
                                  _vm.isBlank(change.newValue)
                                    ? _c(
                                        "span",
                                        { staticClass: "blank-value" },
                                        [_vm._v("blank")]
                                      )
                                    : _c("span", { staticClass: "new-value" }, [
                                        _vm._v(_vm._s(change.newValue)),
                                      ]),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm.isBlank(item.oldValue) &&
                        _vm.$_isJson(item.newValue)
                      ? _c("span", [
                          _c("span", { staticClass: "change-text" }, [
                            _vm._v("set to"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "json-set-view" },
                            _vm._l(
                              _vm.getJsonProperties(item.newValue),
                              function (prop, propIndex) {
                                return _c(
                                  "div",
                                  {
                                    key:
                                      _vm.getUniqueKey(item, index) +
                                      "-prop-" +
                                      propIndex,
                                    staticClass: "json-property",
                                  },
                                  [
                                    prop.path
                                      ? _c(
                                          "span",
                                          { staticClass: "json-path" },
                                          [_vm._v(_vm._s(prop.path) + ":")]
                                        )
                                      : _vm._e(),
                                    _c("span", { staticClass: "new-value" }, [
                                      _vm._v(_vm._s(prop.value)),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ])
                      : _vm.$_isJson(item.oldValue) &&
                        _vm.isBlank(item.newValue)
                      ? _c("span", [
                          _c("span", { staticClass: "change-text" }, [
                            _vm._v("cleared (was:"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "json-set-view" },
                            _vm._l(
                              _vm.getJsonProperties(item.oldValue),
                              function (prop, propIndex) {
                                return _c(
                                  "div",
                                  {
                                    key:
                                      _vm.getUniqueKey(item, index) +
                                      "-prop-" +
                                      propIndex,
                                    staticClass: "json-property",
                                  },
                                  [
                                    prop.path
                                      ? _c(
                                          "span",
                                          { staticClass: "json-path" },
                                          [_vm._v(_vm._s(prop.path) + ":")]
                                        )
                                      : _vm._e(),
                                    _c("span", { staticClass: "old-value" }, [
                                      _vm._v(_vm._s(prop.value)),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                          _c("span", { staticClass: "change-text" }, [
                            _vm._v(")"),
                          ]),
                        ])
                      : _c("span", [
                          item.changeType === "Insert"
                            ? _c("span", [
                                _c("span", { staticClass: "change-text" }, [
                                  _vm._v("added"),
                                ]),
                                _c("span", { staticClass: "new-value" }, [
                                  _vm._v(_vm._s(item.newValue)),
                                ]),
                              ])
                            : item.changeType === "Delete"
                            ? _c("span", [
                                _c("span", { staticClass: "change-text" }, [
                                  _vm._v("removed"),
                                ]),
                                _c("span", { staticClass: "old-value" }, [
                                  _vm._v(_vm._s(item.oldValue)),
                                ]),
                              ])
                            : _c("span", [
                                _c("span", { staticClass: "change-text" }, [
                                  _vm._v("changed from"),
                                ]),
                                _c(
                                  "span",
                                  {
                                    class: _vm.getValueClass(
                                      item.oldValue,
                                      "old"
                                    ),
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(item.oldValue || "blank") +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                                _c("span", { staticClass: "change-text" }, [
                                  _vm._v("to"),
                                ]),
                                _c(
                                  "span",
                                  {
                                    class: _vm.getValueClass(
                                      item.newValue,
                                      "new"
                                    ),
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(item.newValue || "blank") +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]),
                        ]),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ]),
    _vm.hasMore && !_vm.loading
      ? _c("div", { staticClass: "load-more" }, [
          _c(
            "button",
            {
              staticClass: "custom-btn",
              attrs: { disabled: _vm.loadingMore },
              on: { click: _vm.handleLoadMore },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.loadingMore ? "Loading..." : "Load More") +
                  "\n        "
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("TIMESTAMP")]),
        _c("th", [_vm._v("USER")]),
        _c("th", [_vm._v("CATEGORY")]),
        _c("th", [_vm._v("CHANGE")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }